import React from "react";

type FlexProps = {
  children: React.ReactNode;
  vertical?: boolean;
  wrap?: boolean | "wrap" | "nowrap" | "wrap-reverse";
  justify?:
    | "center"
    | "flex-start"
    | "flex-end"
    | "space-between"
    | "space-around"
    | "space-evenly";
  align?: "center" | "flex-start" | "flex-end" | "stretch" | "baseline";
  gap?: number | "small" | "middle" | "large" | string;
  style?: React.CSSProperties;
  className?: string;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  //ref?: React.RefObject<HTMLDivElement>;
};

/**
 * Flex component for flexbox layout
 * based on Ant Design's v5 Flex component
 */
const Flex = React.forwardRef<HTMLDivElement, FlexProps>(
  (
    {
      children,
      vertical = false,
      wrap = false,
      justify,
      align,
      gap,
      className,
      style = {},
      onClick,
    },
    ref
  ) => {
    const combinedStyle: React.CSSProperties = {
      display: "flex",
      flexDirection: vertical ? "column" : "row",
      flexWrap: wrap === true ? "wrap" : wrap === false ? "nowrap" : wrap,
      justifyContent: justify,
      alignItems: align,
      gap: typeof gap === "number" ? `${gap}px` : gap,
      ...style,
    };

    return (
      <div
        ref={ref}
        style={combinedStyle}
        className={className}
        onClick={onClick}
      >
        {children}
      </div>
    );
  }
);

export default Flex;
